const cookieName = 'BAO-recently-viewed'
const cookieLifetime = 7

window.BAO.buildRecentlyViewed = function() {
  const productDataEl = document.querySelector('[data-product-handle]')
  const productHandle =
    productDataEl && productDataEl.dataset.productHandle
      ? productDataEl.dataset.productHandle
      : null
  const productHandleArray = window.BAO.Utils.getCookie(cookieName).length ? window.BAO.Utils.getCookie(cookieName).split('||') : []

  if (productHandle && !productHandleArray.includes(productHandle)) {
    productHandleArray.push(productHandle)
    window.BAO.Utils.setCookie(cookieName, productHandleArray.join('||'), cookieLifetime)
  }
}

class RecentlyViewed extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    const handles = window.BAO.Utils.getCookie(cookieName).split('||').filter(Boolean);
    const recentFirst = [...handles].reverse(); // Most recent first
    this.render(recentFirst);
  }

  async render (productHandles) {
    this.newProductHandleArray = productHandles

    if (productHandles[0] != '') {
      let productCards = await this.getProductCards(productHandles)

      // Filter out null cards - A null entry is for a handle that doesn't exist
      productCards = productCards.filter(productCard => productCard !== null)

      this.setAttribute('data-item-count', productCards.length)

      if (productCards.length >= 1) {
        this.querySelector('.sec-RecentlyViewed_Slides').innerHTML = productCards.join(
          '',
        )

        const carousel = this.closest('slider-tabs-carousel')
        const next = carousel?.querySelector('[data-slider-tabs-carousel-el="next"]')
        const prev = carousel?.querySelector('[data-slider-tabs-carousel-el="prev"]')
        const spacing = Number(carousel?.dataset.blockGap)
        const spacingValue = Number.isNaN(spacing) == true ? 5 : spacing

        new window.KeenSlider(
          this.querySelector("[data-recently-viewed-el='slides']"),
          {
            selector: "[data-recently-viewed-el='slide']",
            defaultAnimation: {
              duration: 1500,
            },
            loop: false,
            mode: 'snap',
            rubberband: false,
            slides: {
              perView: 2.25,
              spacing: spacingValue,
            },
            breakpoints: {
              '(min-width: 768px)': {
                slides: {
                  perView: 4,
                  spacing: spacingValue,
                },
              }
            },
          },
          [
            window.BAO.Carousel.plugins.useInitialised(),
            window.BAO.Carousel.plugins.useArrows({
              next,
              previous: prev,
            })
          ],
        )
      } else {
        this.closest('.shopify-section').remove()
      }

      this.setAttribute('aria-busy', 'false')

      // Update the recently viewed cookie to ensure handles that no longer exist are removed
      window.BAO.Utils.setCookie(cookieName, this.newProductHandleArray.join('||'), cookieLifetime)
    } else {
      this.closest('.shopify-section').remove()
    }
  }

  getProductCards (handles) {
    const limit = this.dataset.productLimit ? parseInt(this.dataset.productLimit) : 4
    if (this.dataset.showCurrentProduct === 'false') {
      handles = handles.filter(handle => handle !== this.dataset.currentProductHandle)
    }

    return Promise.all(
      handles.slice(0, limit).map(currentHandle =>
        fetch(`/products/${currentHandle}?view=card`)
          .then(r => {
            // Handles that don't exist will return a 404
            if (r.status === 200 && r.redirected === false) {
              return r.text()
            } else {
              // Remove handles that don't exist
              this.newProductHandleArray = this.newProductHandleArray.filter(
                handle => handle !== currentHandle,
              )
              return null
            }
          })
          .then(r => {
            if (r) {
              return `<div class="sec-RecentlyViewed_Slide keen-slider__slide" data-recently-viewed-el="slide">${r}</div>`
            }
            return null
          }),
      ),
    )
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed)
}
